module.exports = __webpack_public_path__ + "static/media/group-2.241eed40.svg";